module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "background-color": "#F5F5F5",
      "height": "0.2rem"
    }
  }), _vm._v(" "), _vm._l((_vm.orderList), function(item) {
    return _c('div', {
      staticStyle: {
        "width": "92%",
        "margin": "0 auto 0 auto"
      }
    }, [_c('div', {
      staticClass: "Grey",
      on: {
        "click": function($event) {
          return _vm.goDetail(item.ParentResvNo, item.TotalPrice, '取消订单')
        }
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "height": "0.7rem"
      }
    }, [_c('span', {
      staticClass: "Orange",
      staticStyle: {
        "margin-left": "5px",
        "margin-top": "10px",
        "font-weight": "700",
        "font-size": "0.28rem",
        "float": "left"
      }
    }, [_c('div', [_vm._v(_vm._s(_vm.orderState(item)))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-right": "10px",
        "margin-top": "10px",
        "font-size": "0.24rem",
        "float": "right"
      }
    }, [_vm._v("\n\t\t\t\t\t查看详情\n\t\t\t\t\t"), _c('mu-icon', {
      staticStyle: {
        "position": "relative",
        "top": "4px"
      },
      attrs: {
        "value": "keyboard_arrow_right",
        "color": "#D4D4D4",
        "size": 16
      }
    })], 1)]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "border": "none",
        "border-top": "1px solid #F1F1F1"
      }
    }), _vm._v(" "), _c('table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "align": "center",
        "border": "0"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "26%"
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "1.2rem",
        "max-width": "1.6rem",
        "margin": "-5% 0 0 -5%"
      },
      attrs: {
        "src": item.HotelLogo != '' ? item.HotelLogo : '../../../static/search/noImg.jpg'
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "color": "#333333",
        "font-weight": "700",
        "width": "98%"
      }
    }, [_vm._v(" " + _vm._s(item.HotelName) + " ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-top": "0.1rem",
        "line-height": "1.6",
        "font-size": "0.22rem",
        "float": "left"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t入住： " + _vm._s(_vm._f("dayTime")(item.Arrivedate)) + "\n\t\t\t\t\t\t\t"), _c('br'), _vm._v(" 离开： " + _vm._s(_vm._f("dayTime")(item.Departuredate)) + "\n\t\t\t\t\t\t\t"), _c('br'), _vm._v(" 房型： " + _vm._s(item.RoomTypeNameNew + '(' + item.RoomTypeDisPlayNew + ')') + " × " + _vm._s(item.RoomCount) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#333333",
        "float": "right",
        "margin": "0.2rem 0.15rem 0 0"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "0.26rem"
      }
    }, [_vm._v(" ￥ ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "0.32rem"
      }
    }, [_vm._v(" " + _vm._s(item.TotalPrice) + " ")])])])])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "border": "none",
        "border-top": "1px solid #F1F1F1"
      }
    }), _vm._v(" "), (item.OtherFlag == 0 || item.OtherFlag == 2) ? _c('div', [(item.listResvPayInfo[0].PayStatus == '0') ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n\t\t\t\t\t备注：如遇特殊情况，不能及时入住，您可以在\n\t\t\t\t\t"), _vm._v(" "), (item.SpecialCode == 'C0000001' || item.SpecialCode == 'C0000075' || item.SpecialCode == 'C0000187') ? _c('span', {
      staticClass: "Orange"
    }, [_vm._v("【入住日前一天】18:00 ")]) : _c('span', {
      staticClass: "Orange"
    }, [_vm._v("【入住当日】18:00 ")]), _vm._v("\n\t\t\t\t\t前免费取消订单。若未入住或逾期取消，将收取您首日房费。\n\t\t\t\t")]) : _c('div', [(item.SpecialCode == '') ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n\t\t\t\t\t\t备注：如您到店较晚，建议您先支付房费，我们将为您保留房间至\n\t\t\t\t\t\t"), (_vm.CardKindDiplay == '员工卡' || _vm.CardKindDiplay == '数字卡' || _vm.CardKindDiplay == '贵宾卡') ? _c('span', {
      staticClass: "Orange"
    }, [_vm._v("离店日 13:00 ")]) : _vm._e(), _vm._v(" "), (_vm.CardKindDiplay == '贝壳卡' || _vm.CardKindDiplay == '铂金卡' || _vm.CardKindDiplay == '金卡' || _vm.CardKindDiplay == '翡翠卡' || _vm.CardKindDiplay == '联名卡') ? _c('span', {
      staticClass: "Orange"
    }, [_vm._v("离店日 14:00 ")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t，期间可随时入住。\n\t\t\t\t\t\t"), _c('span', {
      staticClass: "Orange"
    }, [_vm._v("【入住当日】18:00 ")]), _vm._v("\n\t\t\t\t\t\t之前取消订单可全额退款。超时或未入住将收取您首日房费。\n\t\t\t\t\t")]) : (item.SpecialCode == 'C0000001' || item.SpecialCode == 'C0000075' || item.SpecialCode == 'C0000187') ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n\t\t\t\t\t\t备注：998房或69房需要在30分钟内完成支付，未完成支付将自动取消。支付成功后只能在入住日前一天18:00前免费取消，逾期取消或未入住需收取全额房费作为违约金。\n\t\t\t\t\t")]) : _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n\t\t\t\t\t\t备注：特价房需要在30分钟内完成支付，未完成支付将自动取消。\n\t\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), (item.listResvPayInfo) ? _c('div', [(item.OtherFlag == 1) ? _c('div', [(item.listResvPayInfo[0].PayStatus == '0') ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n\t\t\t\t\t\t备注：休闲房订单取消需提前到达时间4小时以上！\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.listResvPayInfo[0].PayStatus != '0') ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n\t\t\t\t\t\t备注：休闲房需在30分钟内完成支付，未完成支付将自动取消。\n\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.OtherFlag == 4) ? _c('div', [(item.listResvPayInfo[0].PayStatus == '0') ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n\t\t\t\t\t\t备注：已支付凌晨房订单将保留至中午十二点。\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.listResvPayInfo[0].PayStatus != '0') ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n\t\t\t\t\t\t备注：凌晨房订单最晚保留到上午六点，未完成支付将自动取消。\n\t\t\t\t\t")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticStyle: {
        "border": "none",
        "border-top": "1px solid #F1F1F1"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.7rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.1rem"
      }
    }, [(_vm.orderOption(item).showPay) ? _c('div', {
      staticClass: "opBtn payBtn",
      on: {
        "click": function($event) {
          return _vm.payMoney(item.ParentResvNo, item.TotalPrice, item.HoldTime)
        }
      }
    }, [_vm._v("\n\t\t\t\t支付房费\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.orderOption(item).showCancel) ? _c('div', {
      staticClass: "opBtn",
      on: {
        "click": function($event) {
          return _vm.cancelOrder(item.ParentResvNo)
        }
      }
    }, [_vm._v("\n\t\t\t\t取消订单\n\t\t\t")]) : _c('div', {
      staticClass: "opBtn",
      on: {
        "click": function($event) {
          return _vm.deleteOrder(item.ParentResvNo)
        }
      }
    }, [_vm._v("\n\t\t\t\t删除订单\n\t\t\t")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#F5F5F5",
        "height": "0.2rem",
        "width": "114%",
        "margin-left": "-7%"
      }
    })])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79621f96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderList.vue
// module id = 1555
// module chunks = 18